var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Paginate',{attrs:{"container-class":'pagination',"page-count":_vm.option.limit,"force-page":_vm.option.force,"click-handler":_vm.onClick,"no-li-surround":true,"first-last-button":true,"page-range":10,"prev-text":'&#8249;',"next-text":'&#8250;',"first-button-text":'&#171;',"last-button-text":'&#187;'}})
}
var staticRenderFns = []

export { render, staticRenderFns }